import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { MedicalCertificateFormBean } from './form/MedicalCertificateForm.types';

export const medicalCertificateDraftSchema = createObjectSchema<MedicalCertificateFormBean>({
   diagnoses: diagnosesWithBodySideFormPart.draftSchema,
   certificateDetails: createStringSchema().nullable(),
}).strict();

export type MedicalCertificateDraftToken = 'medicalCertificate';
type VisitId = number;
export const getMedicalCertificateDraftToken = (visitId: VisitId): `visit-${VisitId}-${MedicalCertificateDraftToken}` =>
   `visit-${visitId}-medicalCertificate`;
